import http from '@/utils/http';
const base_path = '/v2/tool/wechatGamePlayablePage';

/**
 * 获取微信小游戏试玩页列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getWechatGamePlayablePageListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步微信小游戏试玩页接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const pullWechatGamePlayablePageApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};
